(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cn-collection-example"]) return;
  try {
    



if(!customElements.get('cn-collection-browser'))customElements.define('cn-collection-browser',class extends HTMLElement{



  async connectedCallback(){



    if(this.ready)return;this.ready=true;

    const status=this.querySelector('[role=status]');const grid=this.querySelector('.cc-grid');

    try{if(Number(this.dataset.pages)>1){status.textContent=this.dataset.loading;for(let page=1;page<=Number(this.dataset.pages);page++){if(page===Number(this.dataset.currentPage))continue;const url=new URL(location.href);url.searchParams.set('view','cn-example');url.searchParams.set('page',page);const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('catalog');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const more=[...doc.querySelectorAll('.cc-item')];if(!more.length)throw new Error('catalog');if(page<Number(this.dataset.currentPage))grid.prepend(...more);else grid.append(...more)}if(this.querySelectorAll('.cc-item').length!==Number(this.dataset.total))throw new Error('catalog')}}catch(error){status.textContent=this.dataset.error;return}

    this.querySelector('.cc-server-pagination').hidden=true;



    this.cards=[...this.querySelectorAll('.cc-item')];this.grid=this.querySelector('.cc-grid');this.form=this.querySelector('form');this.sort=this.querySelector('.cc-sort select');this.page=1;this.size=12;



    const panorama=new Set(['prity-pm-e','prity-pm-tv-sl','prity-pm3-e','prity-pm3l-e','prity-pmv-tv','prity-pmv-tv-sl','prity-pmv3-e','prity-p','prity-p-tv','prity-p-w18','prity-p-w18-tv','prity-p-w28-tv','prity-ps2','prity-ps3']);

    const typeMap={"Houtfornuis":["cooking"],"Cooking range":["cooking"],"Kuchnia":["cooking"],"Houtgestookt fornuis":["cooking"],"Cuisinière à bois":["cooking"],"Holzherd":["cooking"],"Cocina de leña":["cooking"],"Cuisinière à bois avec four":["cooking"],"Cucina a legna con forno":["cooking"],"Cuisinière":["cooking"],"Fornuis":["cooking"],"Küchenherd":["cooking"],"Cocina":["cooking"],"Cucina":["cooking"],"Cocina de leña con horno":["cooking"],"Holzherd mit Backofen":["cooking"],"Cucina a legna":["cooking"],"Kuchnia na drewno":["cooking"],"Piec z płaszczem wodnym":["boiler"],"Poêle bouilleur à bois":["boiler"],"Kachel met watermantel":["boiler"],"Termoestufa de leña":["boiler"],"Estufa de leña con circuito de agua":["boiler"],"Hidroestufa":["boiler"],"Termostufa a legna":["boiler"],"Wasserführender Ofen":["boiler"],"Boiler stove":["boiler"],"Poêle bouilleur":["boiler"],"Wasserführender Kaminofen":["boiler"],"Cv-houtkachel":["boiler"],"Termostufa":["boiler"],"Poêle à bois":["room"],"Piec wolnostojący":["room"],"Stufa a legna":["room"],"Raumheizofen":["room"],"Kaminofen":["room"],"Estufa de leña":["room"],"Vrijstaande houtkachel":["room"],"Houtkachel":["room"],"Estufa de ambiente":["room"],"Poêle de chauffage":["room"],"Ruimteverwarmingskachel":["room"],"Estufa de calefacción":["room"],"Piec do ogrzewania pomieszczeń":["room"],"Room stove":["room"],"Stufa per ambiente":["room"],"Cuisinière bouilleur":["cooking","boiler","cooking_boiler"],"Cuisinière à bois bouilleuse":["cooking","boiler","cooking_boiler"],"Cooking range with boiler":["cooking","boiler","cooking_boiler"],"Wasserführender Küchenherd":["cooking","boiler","cooking_boiler"],"Wasserführender Holzherd":["cooking","boiler","cooking_boiler"],"Termocucina a legna":["cooking","boiler","cooking_boiler"],"Cocina de leña con circuito de agua":["cooking","boiler","cooking_boiler"],"Cocina con circuito de agua":["cooking","boiler","cooking_boiler"],"Kuchnia z płaszczem wodnym":["cooking","boiler","cooking_boiler"],"Kuchnia na drewno z płaszczem wodnym":["cooking","boiler","cooking_boiler"],"Termocucina":["cooking","boiler","cooking_boiler"],"Cuisinière bouilleuse à bois":["cooking","boiler","cooking_boiler"],"Houtfornuis met cv-aansluiting":["cooking","boiler","cooking_boiler"],"Houtgestookt cv-fornuis":["cooking","boiler","cooking_boiler"],"Cocina de leña con caldera":["cooking","boiler","cooking_boiler"],"Fornuis met watermantel":["cooking","boiler","cooking_boiler"],"Stufa con forno":["oven"],"Kachel met oven":["oven"],"Kaminofen mit Backofen":["oven"],"Stufa a legna con forno":["oven"],"Piec z piekarnikiem":["oven"],"Poêle à bois avec four":["oven"],"Kaminofen mit Backfach":["oven"],"Estufa con horno":["oven"],"Ofen mit Backofen":["oven"],"Poêle avec four":["oven"],"Houtkachel met oven":["oven"],"Estufa de leña con horno":["oven"],"Stove with oven":["oven"],"Poêle d’angle":["room","corner"],"Eckkaminofen":["room","corner"],"Corner stove":["room","corner"],"Estufa de esquina":["room","corner"],"Piec narożny":["room","corner"],"Hoekkachel":["room","corner"],"Poêle à bois d’angle":["room","corner"],"Estufa de rincón":["room","corner"],"Hoekhaard":["room","corner"],"Stufa angolare":["room","corner"],"Wkład kominkowy":["insert"],"Kamineinsatz":["insert"],"Insert de cheminée à bois":["insert"],"Insert à bois":["insert"],"Inserto per camino":["insert"],"Inbouwhaard":["insert"],"Insert de cheminée":["insert"],"Insertable de leña":["insert"],"Inserto a legna":["insert"],"Fireplace insert":["insert"],"Fireplace insert with boiler":["insert","boiler"],"Insertable con circuito de agua":["insert","boiler"],"Insertable de leña con circuito de agua":["insert","boiler"],"Termocamino a legna":["insert","boiler"],"Insert bouilleur à bois":["insert","boiler"],"Wkład kominkowy z płaszczem wodnym":["insert","boiler"],"Termocamino da incasso":["insert","boiler"],"Insertable de leña con caldera":["insert","boiler"],"Inbouwhaard met watermantel":["insert","boiler"],"Wasserführender Kamineinsatz":["insert","boiler"],"Insert bouilleur":["insert","boiler"],"Cv-inbouwhaard":["insert","boiler"],"Wood-burning cooker":["cooking"]};

    for(const card of this.cards){

      card.dataset.categories=JSON.stringify([...(typeMap[card.dataset.type]||[]),...(panorama.has(card.dataset.handle)?['panoramic']:[])]);

      const tags=card.dataset.tags.split('|'),rows=card.dataset.specs.split('~').map(row=>row.split('|').map(x=>x.replace(/\s+/g,' ').trim()));

      const rowValue=names=>{for(const row of rows){if(row.length>1&&names.some(name=>row[0].toLowerCase().endsWith(name)))return row[1]}return ''};

      const room=rowValue(["moc nominalna oddawana do pomieszczenia", "moc oddawana do pomieszczenia", "moc ogrzewania pomieszczenia", "nennwärmeleistung an den raum", "nominaal vermogen aan de ruimte", "nominal output to the room", "potencia al ambiente", "potencia de calefacción del ambiente", "potencia nominal al ambiente", "potenza all’ambiente", "potenza di riscaldamento dell’ambiente", "potenza nominale all’ambiente", "puissance de chauffage de la pièce", "puissance dégagée dans la pièce", "puissance nominale", "puissance nominale de la pièce", "puissance nominale foyer", "puissance nominale pièce", "puissance nominale restituée à la pièce", "puissance nominale transmise à la pièce", "puissance thermique nominale", "puissance thermique nominale dans la pièce", "puissance thermique nominale restituée à la pièce", "puissance thermique pièce", "puissance transmise à la pièce", "puissance à la pièce", "raumheizleistung", "room heating output", "room output", "space heating output", "vermogen aan de ruimte", "vermogen voor ruimteverwarming"]);

      const nominal=JSON.parse(card.dataset.categories).includes('boiler')?'':rowValue(["moc nominalna", "nennwärmeleistung", "nominaal vermogen", "nominaal warmtevermogen", "nominal heat output", "nominalna moc cieplna", "potencia nominal", "potencia térmica nominal", "potenza nominale", "potenza termica nominale", "puissance nominale", "puissance thermique nominale", "rated heat output"]);

      const tagged=tags.find(t=>/^\d+(?:[.,]\d+)?\s*kW$/i.test(t))||'';

      const match=(room||nominal||tagged||card.dataset.title).match(/(?:^|[^\d.,])(\d+(?:[.,]\d+)?)\s*kW\b/i);const kw=match?Number(match[1].replace(',','.')):null;

      const energyRaw=rowValue(["clase de eficiencia energética", "clase energética", "classe di efficienza energetica", "classe d’efficacité énergétique", "classe energetica", "classe énergétique", "energie-efficiëntieklasse", "energieeffizienzklasse", "energieklasse", "energy class", "energy efficiency class", "klasa efektywności energetycznej", "klasa energetyczna"])||tags.find(t=>/^(A\+{0,3}|[B-G])$/.test(t))||'';const energy=/^(A\+{0,3}|[B-G])$/.test(energyRaw)?energyRaw:'';

      const badges=document.createElement('div');badges.className='cc-spec-badges';

      if(kw>0){card.dataset.kw=kw;const power=document.createElement('span');power.className='cc-power-badge';power.textContent=this.dataset.roomLabel.replace('[power]',kw);badges.append(power);const area=document.createElement('span');area.className='cc-power-badge cc-area-badge';badges.append(area)}

      if(energy){card.dataset.energy=energy;const badge=document.createElement('span');badge.className='cc-power-badge cc-energy-badge';badge.textContent=this.dataset.energyLabel.replace('[energy]',energy);badges.append(badge)}

      if(badges.childElementCount)card.querySelector('.cs-card-title').after(badges);

    }

    for(const input of this.form.querySelectorAll('[name=category]')){const count=this.cards.filter(c=>JSON.parse(c.dataset.categories).includes(input.value)).length;input.parentElement.querySelector('small').textContent=count;input.disabled=count===0;input.parentElement.hidden=count===0}if(this.form.querySelectorAll('[name=category]:not(:disabled)').length<2)this.form.querySelector('[data-type-filter]').hidden=true;

    const energyHolder=this.querySelector('[data-energy-options]');for(const energy of [...new Set(this.cards.map(c=>c.dataset.energy).filter(Boolean))].sort()){const label=document.createElement('label');label.className='cc-check';const input=document.createElement('input');input.type='checkbox';input.name='energy';input.value=energy;const text=document.createElement('span');text.textContent=energy;const count=document.createElement('small');count.textContent=this.cards.filter(c=>c.dataset.energy===energy).length;label.append(input,text,count);energyHolder.append(label)}

    const vendors=[...new Set(this.cards.map(c=>c.dataset.vendor))].sort();const holder=this.querySelector('[data-vendors]');



    for(const vendor of vendors){const label=document.createElement('label');label.className='cc-check';const input=document.createElement('input');input.type='checkbox';input.name='vendor';input.value=vendor;const text=document.createElement('span');text.textContent=vendor;const count=document.createElement('small');count.textContent=this.cards.filter(c=>c.dataset.vendor===vendor).length;label.append(input,text,count);holder.append(label)}



    this.form.hidden=false;this.querySelector('.cc-sort').hidden=false;this.querySelector('.cc-bottom').hidden=false;



    this.form.elements.max.placeholder=Math.ceil(Math.max(0,...this.cards.map(c=>Number(c.dataset.price)))/100);



    if(matchMedia('(max-width:749px)').matches)this.querySelector('details').open=false;



    this.restore();this.render();



    this.form.addEventListener('submit',e=>{e.preventDefault();this.page=1;this.render(true);if(matchMedia('(max-width:749px)').matches)this.querySelector('details').open=false});



    this.form.addEventListener('change',()=>{this.page=1;this.render(true)});



    this.sort.addEventListener('change',()=>{this.page=1;this.render(true)});



    this.form.addEventListener('reset',()=>{setTimeout(()=>{this.form.elements.calcmin.value='';this.form.elements.calcmax.value='';this.page=1;this.sort.value='original';this.render(true)},0)});



    this.querySelector('[data-reset]').addEventListener('click',()=>this.form.reset());



    this.querySelector('.cc-pages').addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;this.page=Number(b.dataset.page);this.render(true);this.querySelector('.cc-toolbar').scrollIntoView({block:'start',behavior:'instant'})});



    this.onPop=()=>{this.restore();this.render()};window.addEventListener('popstate',this.onPop);



  }



  disconnectedCallback(){window.removeEventListener('popstate',this.onPop)}



  restore(){const p=new URL(location.href).searchParams;for(const input of this.form.querySelectorAll('[name=vendor]'))input.checked=p.getAll('cn_brand').includes(input.value);for(const input of this.form.querySelectorAll('[name=kwrange]'))input.checked=p.getAll('cn_kw').includes(input.value);for(const name of ['category','energy','area'])for(const input of this.form.querySelectorAll('[name='+name+']'))input.checked=p.getAll('cn_'+name).includes(input.value);this.form.elements.insulation.value=['10','15','20'].includes(p.get('cn_insulation'))?p.get('cn_insulation'):'15';for(const [field,key] of [['calcmin','cn_calc_min'],['calcmax','cn_calc_max']]){const value=p.get(key);this.form.elements[field].value=value!==null&&Number.isFinite(Number(value))&&Number(value)>=0?value:''}this.form.elements.min.value=p.get('cn_min')||'';this.form.elements.max.value=p.get('cn_max')||'';this.form.elements.available.checked=p.get('cn_available')==='1';this.sort.value=p.get('cn_sort')||'original';this.page=Math.max(1,parseInt(p.get('cn_page')||'1',10)||1)}



  render(save=false){



    const brands=[...this.form.querySelectorAll('[name=vendor]:checked')].map(i=>i.value),min=Number(this.form.elements.min.value||0)*100,max=this.form.elements.max.value===''?Infinity:Number(this.form.elements.max.value)*100,available=this.form.elements.available.checked;



    const kwRanges=[...this.form.querySelectorAll('[name=kwrange]:checked')].map(i=>i.value);const bounds={up_to_5:[0,5],'5_to_8':[5,8],'8_to_12':[8,12],'12_to_16':[12,16],over_16:[16,Infinity]};



    const selected=name=>[...this.form.querySelectorAll('[name='+name+']:checked')].map(i=>i.value),categories=selected('category'),energies=selected('energy'),areas=selected('area'),areaBounds={up_to_30:[0,30],'30_to_60':[30,60],'60_to_90':[60,90],'90_to_120':[90,120],over_120:[120,Infinity]};

    for(const card of this.cards){if(card.dataset.kw){card.dataset.area=Math.floor(Number(card.dataset.kw)*Number(this.form.elements.insulation.value)/2.5);card.querySelector('.cc-area-badge').textContent=this.dataset.areaLabel.replace('[area]',card.dataset.area)}}

    const calcActive=this.form.elements.calcmin.value!==''||this.form.elements.calcmax.value!=='';const calcMin=Number(this.form.elements.calcmin.value||0),calcMax=this.form.elements.calcmax.value===''?Infinity:Number(this.form.elements.calcmax.value);const chip=this.querySelector('[data-calculated-range]');chip.hidden=!calcActive;chip.textContent=chip.dataset.label.replace('[min]',calcMin).replace('[max]',calcMax);

    let filtered=this.cards.filter(c=>(!brands.length||brands.includes(c.dataset.vendor))&&Number(c.dataset.price)>=min&&Number(c.dataset.price)<=max&&(!available||c.dataset.available==='true')&&(!calcActive||(c.dataset.kw&&Number(c.dataset.kw)>=calcMin&&Number(c.dataset.kw)<=calcMax))&&(!categories.length||categories.some(v=>JSON.parse(c.dataset.categories).includes(v)))&&(!energies.length||energies.includes(c.dataset.energy))&&(!areas.length||(c.dataset.area&&areas.some(v=>Number(c.dataset.area)>areaBounds[v][0]&&Number(c.dataset.area)<=areaBounds[v][1])))&&(!kwRanges.length||(c.dataset.kw&&kwRanges.some(key=>Number(c.dataset.kw)>bounds[key][0]&&Number(c.dataset.kw)<=bounds[key][1]))));



    if(this.sort.value==='price-asc')filtered.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));if(this.sort.value==='price-desc')filtered.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));if(this.sort.value==='title')filtered.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));



    const pages=Math.ceil(filtered.length/this.size);this.page=Math.min(this.page,Math.max(1,pages));this.cards.forEach(c=>c.hidden=true);filtered.forEach(c=>this.grid.append(c));filtered.slice((this.page-1)*this.size,this.page*this.size).forEach(c=>c.hidden=false);



    this.querySelector('[data-count]').textContent=this.dataset.count.replace('[count]',filtered.length);this.querySelector('[data-showing]').textContent=this.dataset.showing.replace('[start]',filtered.length?(this.page-1)*this.size+1:0).replace('[end]',Math.min(this.page*this.size,filtered.length)).replace('[count]',filtered.length);this.querySelector('.cc-empty').hidden=filtered.length>0;



    const nav=this.querySelector('.cc-pages');nav.replaceChildren();for(let i=1;i<=pages;i++){const b=document.createElement('button');b.type='button';b.textContent=i;b.dataset.page=i;b.setAttribute('aria-label',this.dataset.pageLabel.replace('[number]',i));if(i===this.page)b.setAttribute('aria-current','page');nav.append(b)}



    if(save){const url=new URL(location.href);['cn_calc_min','cn_calc_max','cn_category','cn_energy','cn_area','cn_insulation','cn_kw','cn_kwmin','cn_kwmax','cn_brand','cn_min','cn_max','cn_available','cn_sort','cn_page'].forEach(k=>url.searchParams.delete(k));for(const [field,key] of [['calcmin','cn_calc_min'],['calcmax','cn_calc_max']])if(this.form.elements[field].value!=='')url.searchParams.set(key,this.form.elements[field].value);for(const name of ['category','energy','area'])selected(name).forEach(v=>url.searchParams.append('cn_'+name,v));if(this.form.elements.insulation.value!=='15')url.searchParams.set('cn_insulation',this.form.elements.insulation.value);url.searchParams.delete('page');brands.forEach(v=>url.searchParams.append('cn_brand',v));kwRanges.forEach(v=>url.searchParams.append('cn_kw',v));if(this.form.elements.min.value)url.searchParams.set('cn_min',this.form.elements.min.value);if(this.form.elements.max.value)url.searchParams.set('cn_max',this.form.elements.max.value);if(available)url.searchParams.set('cn_available','1');if(this.sort.value!=='original')url.searchParams.set('cn_sort',this.sort.value);if(this.page>1)url.searchParams.set('cn_page',this.page);history.replaceState(null,'',url)}



  }



});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-product-example"]) return;
  try {
    
const source=document.querySelector('.cp-source-description');const documents=document.querySelector('[data-cp-documents]');if(source&&documents){const seen=new Set();source.querySelectorAll('a[href]').forEach(link=>{const url=new URL(link.getAttribute('href'),location.origin);if(url.protocol!=='https:'||url.origin===location.origin)return;const isDocument=/\.(pdf|jpg|jpeg|png)(?:$|\?)/i.test(url.pathname)||/manufacturer|official|document|energy|declaration/i.test(link.textContent);if(!isDocument||seen.has(url.href))return;seen.add(url.href);const a=document.createElement('a');a.href=url.href;a.target='_blank';a.rel='noopener';const badge=document.createElement('span');badge.className='cp-pdf';badge.textContent=/\.pdf$/i.test(url.pathname)?'PDF':'↗';const text=document.createElement('strong');text.textContent=link.textContent.trim();a.append(badge,text);documents.append(a);});}if(source){source.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));source.querySelectorAll('a[href="#cp-help"]').forEach(a=>a.href='mailto:info@casanovae24.com');}


if(new URLSearchParams(location.search).has('view')){const info=document.querySelector('product-info');if(info)info.dataset.updateUrl='false';}

document.querySelectorAll('[data-cp-buy]').forEach(button=>button.addEventListener('click',()=>{const target=document.querySelector('variant-selects')||document.querySelector('product-form');if(target){target.scrollIntoView({behavior:'smooth',block:'center'});const control=target.querySelector('input,button');if(control)control.focus({preventScroll:true});}}));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-product-studio"]) return;
  try {
    

document.querySelectorAll('.cn-studio').forEach(root=>{

 const tabs=[...root.querySelectorAll('[role=tab]')];

 const activate=tab=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',active);t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});};

 tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();activate(tabs[n]);tabs[n].focus();}});});

 const source=root.querySelector('.cs-description'),docs=root.querySelector('.cs-documents'),seen=new Set(Array.from(root.querySelectorAll('#cs-docs a[href]'),link=>link.href));
 if(source){
 source.querySelectorAll('a[href]').forEach(link=>{let url;try{url=new URL(link.getAttribute('href'),location.origin);}catch{return;}if(url.protocol!=='https:'||url.origin===location.origin||seen.has(url.href))return;seen.add(url.href);const a=document.createElement('a');a.href=url.href;a.target='_blank';a.rel='noopener';a.textContent=(link.textContent.trim()||url.hostname)+' ↗';docs.append(a);});
 source.querySelectorAll('table').forEach(table=>{const heading=table.previousElementSibling;if(heading&&/^H[2-6]$/.test(heading.tagName))heading.remove();table.remove();});
 source.querySelectorAll('.cp-technical').forEach(el=>el.remove());
 source.querySelectorAll('p').forEach(p=>{if(/HETAS|UK mainland|Royaume-Uni continental|britischen Festland|Regno Unito continentale|Reino Unido continental|vasteland van het Verenigd Koninkrijk|kontynentalnej części Wielkiej Brytanii/i.test(p.textContent)){const h=p.previousElementSibling;if(h&&/^H[2-6]$/.test(h.tagName))h.remove();p.remove();}});
 source.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
 source.querySelectorAll('h2,h3,h4').forEach(h=>{const next=h.nextElementSibling;if(!next||/^H[2-6]$/.test(next.tagName))h.remove();});
 source.querySelectorAll('a[href="#cp-help"]').forEach(a=>a.href='mailto:info@casanovae24.com');
 }
 const info=document.querySelector('product-info');if(info)info.dataset.updateUrl='false';

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-shop-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cn-hero-slider')) {
  customElements.define('cn-hero-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pauseButton = this.querySelector('[data-pause]');
      if (this.slides.length < 2) return;
      this.querySelector('.cs-slider-controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.editorSelected = true; this.show(index); }
      }, options);
      document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
      this.updatePause();
      this.show(0);
    }
    updatePause() {
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      this.pauseButton.querySelector('span').textContent = this.paused ? '\u25b6' : '\u275a\u275a';
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      const next = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
      if (next) next.loading = 'eager';
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editorSelected || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
